import styled from 'styled-components';

const css = styled.div;

export const ProgressColor = css<any>`
   .progress-bar {
      background-color: ${(props) => props.color} !important;
   }
`;

export default css`
   .btn-search {
      padding-top: 23px;
   }

   .status {
      font-weight: bold;
      text-transform: uppercase;
      font-size: 13px;
      color: #56c470;

      &.blocked {
         color: #dc3545 !important;
      }
   }

   .hour {
      font-weight: 800;
      font-size: 12px;
      color: #349bd3;
   }

   .selected {
      background: #d2ebf8 !important;
   }

   .checkbox-container .checkbox:after {
      border: none;
   }
`;
